import { render, staticRenderFns } from "./ClaroSelect.vue?vue&type=template&id=669007f2"
import script from "./ClaroSelect.vue?vue&type=script&lang=js"
export * from "./ClaroSelect.vue?vue&type=script&lang=js"
import style0 from "./ClaroSelect.vue?vue&type=style&index=0&id=669007f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports